import { render, staticRenderFns } from "./DisasterNeedForm.vue?vue&type=template&id=2f496456&"
import script from "./DisasterNeedForm.vue?vue&type=script&lang=js&"
export * from "./DisasterNeedForm.vue?vue&type=script&lang=js&"
import style0 from "./DisasterNeedForm.vue?vue&type=style&index=0&id=2f496456&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports